import React, { Component } from 'react';

import {
    Switch,
    Redirect,
    Route,
    withRouter
} from "react-router-dom";

import PreMenu from './public/components/Restaurant/PreMenu';
import UserAgreements from './public/components/Disclaimer/userAgreements';
import { connect } from 'react-redux';
import Restaurant from './public/components/Restaurant';
import MenuPdf from './public/components/Restaurant/MenuPDF';
import NewsletterForm from './public/components/Newsletter/NewsletterForm';
import PublicImpressum from './public/components/Disclaimer/impressum';
import PublicDataProtection from './public/components/Disclaimer/DataProtection';
import PageNotfound from '../PageNotFound';
import AiChat from './public/components/AiChat';
import { getHubConfig } from '../../api/layOutApiService';
import { setHubConfig } from '../../redux/actions';

class Content extends Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        if (this.props.company_id) {
            this.loadHubConfig();
        }
    }

    loadHubConfig = async () => {
        const response = await getHubConfig(this.props.company_id);
        this.props.dispatch(setHubConfig({
            ...response.data.payload,
        }));
    };


    shouldComponentUpdate(nextProps, nextState) {
        let actualRestaurantType = this.props.restaurantMenuType;
        let nextRestaurantType = nextProps.restaurantMenuType;
        if (!actualRestaurantType && typeof nextRestaurantType) {
            return true;
        }

        let nextVertical = nextProps.vertical_id;
        let actualVertical = this.props.vertical_id;
        if (!actualVertical && typeof nextVertical === 'number') {
            return true;
        }

        return true
    }

    render() {
        const { vertical_id, restaurantMenuType } = this.props;
        const vertical = parseInt(vertical_id);
        return (
            <div className="tablet-wrapper">
                <div className="tablet-content-wrapper">
                    {
                        typeof vertical === 'number' &&
                        <Switch>
                            <Redirect exact from='/public/welcome' to='/public/welcome/form' />
                            <Route path={`/public/welcome/impressum`} component={PublicImpressum} />
                            <Route path={`/public/welcome/data-protection`} component={PublicDataProtection} />
                            {/* Restaurant Vertical */}
                            {
                                (vertical && ((vertical === 3 && restaurantMenuType) || vertical === 4)) &&
                                <Switch>
                                    <Route exact path={`/public/welcome/form`} component={PreMenu} />
                                    <Route exact path={`/public/welcome/form/newsletter-form`} component={NewsletterForm} />>
                                    <Route path={`/public/welcome/form/ai`} component={AiChat} />
                                    {restaurantMenuType && restaurantMenuType !== 'pdf' &&
                                        <Route path={`/public/welcome/form/menu`} component={Restaurant} />
                                    }
                                    {restaurantMenuType && restaurantMenuType === 'pdf' &&
                                        <Route path={`/public/welcome/form/static`} component={MenuPdf} />
                                    }
                                    <Route path={`/public/welcome/privacy`} component={UserAgreements} />
                                    <Route path="/public/welcome/*" component={PageNotfound}/>
                                </Switch>
                            }
                            {/* Default Vertical */}
                            {
                                (vertical && vertical !== 3 && vertical !== 4) &&
                                <Switch>
                                    <Route path={`/public/welcome/privacy`} component={UserAgreements} />
                                </Switch>
                            }
                        </Switch>
                    }
                </div>
                <div id="tablet-modal"></div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        vertical_id: state.companyConfig.vertical_id,
        company_id: state.companyConfig.company_id,
        restaurantMenuType: state.digitalMenuConfig.type,
    };
};

export default withRouter(connect(mapStateToProps)(Content));